import { IState } from '../../store';

export function isRenterFormEnabled(state: IState) {
  const { offer } = state.offerData;
  const isDealRent = Boolean(offer.isByHomeowner && Boolean(offer.dealRentVersion));

  return state.isRenterFormEnabled && isDealRent;
}
